import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckBoxContainer } from './gyoshuCondition.styles';
import React, { ReactNode } from 'react';

interface ChubunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface ChubunruiInfoProps {
    chubunruiList: ChubunruiInfo[],
    checkCode: Set<string>,
    toggleChubunrui(v: string): void,
    children?: ReactNode;
}

interface ChubunruiCheckBoxProps {
    chubunrui: ChubunruiInfo,
    checked: boolean,
    toggleChubunrui(v: string): void,
}

const ChubunruiListContainer = React.memo(ChubunruiListComponent)
function ChubunruiListComponent(props: ChubunruiInfoProps) {
    return (
        <CheckBoxContainer>
            {props.chubunruiList.map((v) => {
                let checked = props.checkCode.has(v.GYSHCD)
                return (
                    <>
                        {<><ChubunruiCheckBoxCompornent chubunrui={v} checked={checked} toggleChubunrui={props.toggleChubunrui} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const ChubunruiCheckBoxCompornent = React.memo((props: ChubunruiCheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.chubunrui.GYSHMKNJ1}
        key={props.chubunrui.GYSHCD}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleChubunrui(props.chubunrui.GYSHCD)} />} />
    )
})

interface ShobunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface ShobunruiInfoProps {
    shobunruiList: ShobunruiInfo[],
    checkCode: Set<string>,
    toggleShobunrui(v: string): void,
    children?: ReactNode;
}

interface ShobunruiCheckBoxProps {
    shobunrui: ShobunruiInfo,
    checked: boolean,
    toggleShobunrui(v: string): void,
}

const ShobunruiListContainer = React.memo(ShobunruiListComponent)

function ShobunruiListComponent(props: ShobunruiInfoProps) {
    return (
        <CheckBoxContainer>
            {props.shobunruiList.map((v) => {
                let checked = props.checkCode.has(v.GYSHCD)
                return (
                    <>
                        {<><ShobunruiCheckBoxCompornent shobunrui={v} checked={checked} toggleShobunrui={props.toggleShobunrui} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const ShobunruiCheckBoxCompornent = React.memo((props: ShobunruiCheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.shobunrui.GYSHMKNJ1}
        key={props.shobunrui.GYSHCD}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleShobunrui(props.shobunrui.GYSHCD)} />} />
    )
})

interface SaibunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface SaibunruiInfoProps {
    saibunruiList: SaibunruiInfo[],
    checkCode: Set<string>,
    toggleSaibunrui(v: string): void,
    children?: ReactNode;
}

interface SaibunruiCheckBoxProps {
    saibunrui: SaibunruiInfo,
    checked: boolean,
    toggleSaibunrui(v: string): void,
}

const SaibunruiListContainer = React.memo(SaibunruiListComponent)
function SaibunruiListComponent(props: SaibunruiInfoProps) {
    return (
        <CheckBoxContainer>
            {props.saibunruiList.map((v) => {
                let checked = props.checkCode.has(v.GYSHCD)
                return (
                    <>
                        {<><SaibunruiCheckBoxCompornent saibunrui={v} checked={checked} toggleSaibunrui={props.toggleSaibunrui} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const SaibunruiCheckBoxCompornent = React.memo((props: SaibunruiCheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.saibunrui.GYSHMKNJ1}
        key={props.saibunrui.GYSHCD}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleSaibunrui(props.saibunrui.GYSHCD)} />} />
    )
})


export { ChubunruiListContainer, ShobunruiListContainer, SaibunruiListContainer }
